export const orderAccountsVouchers = (balances) => {

    let arrayorderaccounts = [
        {
            name : "AHORRO"
        },
        {
            name : "CORRESPONSALIA"
        },
        {
            name : "AHORRO MENORES DE EDAD"
        },
        {
            name : "CERTIFICADOS DE APORTACION"
        },
        {
            name : "AHORRO PROGRAMADO"
        }
    ]

    let resultorderarray = [];

    arrayorderaccounts.forEach(element => {
        
        balances.forEach(balance => {

                if(element.name === balance.Tipo){
                    resultorderarray.push(balance)
                }
            }
        )
    });

    return resultorderarray;
}